<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useArrowsAiAccount } from 'dashboard/composables/useArrowsAiAccount';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import ConnectInboxForm from './ConnectInboxForm.vue';

defineProps({
  options: { type: Array, default: () => [] },
});

const emit = defineEmits(['close', 'submit']);
const { t } = useI18n();
const { inboxesPerAssistant } = useArrowsAiAccount();
const dialogRef = ref(null);

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    position="top"
    :title="t('ARROWS_AI.INBOXES.CREATE_TITLE')"
    :description="
      t('ARROWS_AI.INBOXES.CREATE_DESCRIPTION', {
        count: inboxesPerAssistant,
      })
    "
    :show-cancel-button="false"
    :show-confirm-button="false"
    @close="emit('close')"
  >
    <ConnectInboxForm
      :options="options"
      @submit="emit('submit', $event)"
      @cancel="dialogRef.close()"
    />
    <template #footer />
  </Dialog>
</template>
